import { render } from "./footer_section.html?vue&type=template&id=7fe5224e&external"
import script from "./footer_section.js?vue&type=script&lang=js&external"
export * from "./footer_section.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__